/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * How close the action is to its deadline, derived live from dueDate. Absent once the action is completed, cancelled or awaiting sign-off, where a deadline bucket no longer applies.
 */
export enum FollowUpActionResponseDtoDueStatus {
  OVERDUE = "OVERDUE",
  DUE_SOON = "DUE_SOON",
  OPEN = "OPEN",
}
